// extracted by mini-css-extract-plugin
export var container = "_3l-0";
export var error = "_3l-9";
export var label = "_3l-5";
export var light = "_3l-6";
export var md = "_3l-3";
export var sm = "_3l-2";
export var thin = "_3l-8";
export var thinBold = "_3l-7";
export var vertical = "_3l-4";
export var xs = "_3l-1";